import { ArrowUpRight } from "lucide-react";
import Reveal, { Overline } from "./Reveal";
import { SERVICES } from "../data/content";

export default function Services() {
  return (
    <section id="services" data-testid="services" className="py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <Reveal>
            <Overline>What We Do</Overline>
            <h2 className="mt-6 max-w-2xl font-display text-4xl font-medium uppercase leading-[0.95] tracking-tighter sm:text-5xl">
              Full-spectrum port &amp; marine support
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-sm font-light leading-relaxed text-steel sm:text-base">
              From shipping clearance to heavy salvage — one responsive local
              partner for every port and marine requirement, around the clock.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mt-14">
          <div className="divide-y divide-line border-y border-line">
            {SERVICES.map((s) => (
              <div
                key={s.index}
                data-testid={`service-row-${s.index}`}
                className="group relative overflow-hidden"
              >
                <div className="absolute inset-0 translate-y-full bg-brand transition-transform duration-500 ease-out group-hover:translate-y-0" />
                <div className="relative z-10 grid items-center gap-3 px-1 py-7 transition-colors duration-300 lg:grid-cols-12 lg:gap-6 lg:py-9">
                  <h3 className="font-display text-2xl uppercase tracking-tight text-slate-100 transition-all duration-300 group-hover:translate-x-2 group-hover:text-ink lg:col-span-5 lg:text-3xl">
                    {s.title}
                    {s.flagship && (
                      <span className="ml-3 inline-block border border-brand px-2 py-0.5 align-middle font-mono text-[9px] uppercase tracking-[0.2em] text-brand transition-colors duration-300 group-hover:border-ink group-hover:text-ink">
                        Flagship
                      </span>
                    )}
                  </h3>
                  <p className="text-sm font-light leading-relaxed text-steel transition-colors duration-300 group-hover:text-ink/90 lg:col-span-6">
                    {s.desc}
                  </p>
                  <div className="hidden justify-end lg:col-span-1 lg:flex">
                    <ArrowUpRight
                      size={22}
                      className="-translate-x-2 text-slate-100 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:text-ink group-hover:opacity-100"
                    />
                  </div>
                  <div className="flex flex-wrap gap-2 lg:hidden">
                    {s.tags.map((t) => (
                      <span
                        key={t}
                        className="border border-line px-2 py-1 font-mono text-[9px] uppercase tracking-[0.14em] text-steel transition-colors duration-300 group-hover:border-ink group-hover:text-ink"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
